module.exports = "/_next/static/images/d2af2d786c90bfca174a5ab7e4e01780-hero-mobile-v1.jpg";